import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { pickHTMLProps } from 'pick-react-known-prop';
import { makeStyles } from '@material-ui/core/styles';
import Helmet from 'react-helmet';
import FlexContainerColumn from '@sprinx/react-mui-components/FlexContainerColumn';
import useRouteLocation from '@sprinx/react-routes/useRouteLocation';
import usePageHistory from '../usePageHistory';
import PageBreadcrumbs from '../PageBreadcrumbs';
import PageContext from './PageContext';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      margin: 0,
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center'
    },
    content: {
      width: "calc(100% - ".concat(theme.spacing(4), "px)")
    }
  };
});
/**
 * @components
 */

function Page(_ref) {
  var breadcrumbItems = _ref.breadcrumbItems,
      BreadcrumbsProps = _ref.BreadcrumbsProps,
      children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      disableBreadcrumbs = _ref.disableBreadcrumbs,
      disableHelmet = _ref.disableHelmet,
      disableLogToHistory = _ref.disableLogToHistory,
      initialTitle = _ref.title,
      rest = _objectWithoutProperties(_ref, ["breadcrumbItems", "BreadcrumbsProps", "children", "classes", "className", "disableBreadcrumbs", "disableHelmet", "disableLogToHistory", "title"]);

  var classes = useStyles({
    classes: pClasses,
    className: className
  });
  var location = useRouteLocation();

  var _usePageHistory = usePageHistory(),
      _usePageHistory2 = _slicedToArray(_usePageHistory, 1),
      addToPageHistory = _usePageHistory2[0];

  var _useState = useState({
    title: initialTitle
  }),
      _useState2 = _slicedToArray(_useState, 2),
      ctx = _useState2[0],
      setCtx = _useState2[1];

  useEffect(function () {
    if (ctx.title && !disableLogToHistory) {
      addToPageHistory({
        location: location.pathname,
        title: ctx.title
      });
    }
  }, [addToPageHistory, ctx.title, disableLogToHistory, location.pathname]);

  var handleSetPageTitle = function handleSetPageTitle(nextTitle) {
    setCtx(function (pCtx) {
      return _extends({}, pCtx, {
        title: nextTitle
      });
    });
  };

  return React.createElement(PageContext.Provider, {
    value: _extends({}, ctx, {
      setPageTitle: handleSetPageTitle
    })
  }, ctx.title && !disableHelmet && React.createElement(Helmet, null, React.createElement("title", null, ctx.title)), React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), React.createElement(FlexContainerColumn, {
    className: classes.content,
    noFlexGrow: true
  }, !disableBreadcrumbs && React.createElement(PageBreadcrumbs, BreadcrumbsProps, breadcrumbItems), children)));
} // ************************


Page.propTypes = {
  breadcrumbItems: PropTypes.node,
  BreadcrumbsProps: PropTypes.shape({}),

  /**
   * Obsah Page => node
   */
  children: PropTypes.node,
  classes: PropTypes.shape({
    content: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,

  /**
   * Pokud je `true` nezobrazi se breadcrumbs.
   */
  disableBreadcrumbs: PropTypes.bool,

  /**
   * Pokud je `true` nenastavi se `document.title` dle title stranky
   */
  disableHelmet: PropTypes.bool,

  /**
   * Pokud je `true` zobrazeni stanky se nebude zapisovat do historie zobrazeni.
   */
  disableLogToHistory: PropTypes.bool,

  /**
   * Text vlozeny do `document.title`. Pokud neni definovan, nadpis se nezobrazuje.
   */
  title: PropTypes.string
}; // ************************

Page.defaultProps = {
  breadcrumbItems: null,
  BreadcrumbsProps: {},
  children: null,
  classes: undefined,
  className: undefined,
  disableBreadcrumbs: false,
  disableHelmet: false,
  disableLogToHistory: false,
  title: undefined
};
export default Page;